export const isProd = (): boolean => {return env() === 'production';};
export const env = (): string => {return process.env.NODE_ENV;};
